/* tslint:disable */
/* eslint-disable */
/**
 * API
 * API
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction, replaceWithSerializableTypeIfNeeded } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { CalendarDto } from '../models';
// @ts-ignore
import type { CalendarEventByDateDto } from '../models';
// @ts-ignore
import type { CalendarEventsSearchRequestDto } from '../models';
/**
 * RestCalendarApi - axios parameter creator
 */
export const RestCalendarApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get list of user calendars
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCalendars: async (userId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('getCalendars', 'userId', userId)
            const localVarPath = `/api/users/{userId}/calendars`
                .replace('{userId}', encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Search for calendar events
         * @param {CalendarEventsSearchRequestDto} calendarEventsSearchRequestDto Calendar events search request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchCalendarEvents: async (calendarEventsSearchRequestDto: CalendarEventsSearchRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'calendarEventsSearchRequestDto' is not null or undefined
            assertParamExists('searchCalendarEvents', 'calendarEventsSearchRequestDto', calendarEventsSearchRequestDto)
            const localVarPath = `/api/calendar-events-search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(calendarEventsSearchRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * RestCalendarApi - functional programming interface
 */
export const RestCalendarApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = RestCalendarApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Get list of user calendars
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCalendars(userId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CalendarDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCalendars(userId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestCalendarApi.getCalendars']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Search for calendar events
         * @param {CalendarEventsSearchRequestDto} calendarEventsSearchRequestDto Calendar events search request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async searchCalendarEvents(calendarEventsSearchRequestDto: CalendarEventsSearchRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CalendarEventByDateDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.searchCalendarEvents(calendarEventsSearchRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestCalendarApi.searchCalendarEvents']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * RestCalendarApi - factory interface
 */
export const RestCalendarApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = RestCalendarApiFp(configuration)
    return {
        /**
         * 
         * @summary Get list of user calendars
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCalendars(userId: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<CalendarDto>> {
            return localVarFp.getCalendars(userId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Search for calendar events
         * @param {CalendarEventsSearchRequestDto} calendarEventsSearchRequestDto Calendar events search request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchCalendarEvents(calendarEventsSearchRequestDto: CalendarEventsSearchRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<Array<CalendarEventByDateDto>> {
            return localVarFp.searchCalendarEvents(calendarEventsSearchRequestDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * RestCalendarApi - interface
 */
export interface RestCalendarApiInterface {
    /**
     * 
     * @summary Get list of user calendars
     * @param {string} userId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getCalendars(userId: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<CalendarDto>>;

    /**
     * 
     * @summary Search for calendar events
     * @param {CalendarEventsSearchRequestDto} calendarEventsSearchRequestDto Calendar events search request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    searchCalendarEvents(calendarEventsSearchRequestDto: CalendarEventsSearchRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<Array<CalendarEventByDateDto>>;

}

/**
 * RestCalendarApi - object-oriented interface
 */
export class RestCalendarApi extends BaseAPI implements RestCalendarApiInterface {
    /**
     * 
     * @summary Get list of user calendars
     * @param {string} userId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getCalendars(userId: string, options?: RawAxiosRequestConfig) {
        return RestCalendarApiFp(this.configuration).getCalendars(userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Search for calendar events
     * @param {CalendarEventsSearchRequestDto} calendarEventsSearchRequestDto Calendar events search request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public searchCalendarEvents(calendarEventsSearchRequestDto: CalendarEventsSearchRequestDto, options?: RawAxiosRequestConfig) {
        return RestCalendarApiFp(this.configuration).searchCalendarEvents(calendarEventsSearchRequestDto, options).then((request) => request(this.axios, this.basePath));
    }
}

